import type { MemberGender } from '@bm/contracts';

export type RosterChipVariant = 'positive' | 'negative' | 'uncertain';

/** Used on both the season-match and training-event cards for visual parity.
 * A "negative" response (declined) always wins as red+strikethrough,
 * regardless of gender; "uncertain" (vielleicht/Warteliste) gets an amber
 * ring on top of the regular chip. The regular chip itself follows the
 * same Geschlecht-Konvention as `gender-colors.ts` (blau/männlich, rosa/
 * weiblich) — auf Wunsch des Vereins, damit weibliche Spielerinnen auf
 * einen Blick erkennbar sind, ohne den Namen lesen zu müssen. */
export function rosterChipClass(variant: RosterChipVariant, gender: MemberGender | null): string {
  if (variant === 'negative') return 'bg-rose-50 text-red-600 line-through';
  const base = gender === 'w' ? 'bg-pink-100 text-pink-700' : 'bg-blue-100 text-blue-700';
  return variant === 'uncertain' ? `${base} ring-1 ring-amber-400` : base;
}
